import { render, staticRenderFns } from "./x-checkbox.vue?vue&type=template&id=4b1252af&scoped=true&"
import script from "./x-checkbox.vue?vue&type=script&lang=js&"
export * from "./x-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./x-checkbox.vue?vue&type=style&index=0&id=4b1252af&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1252af",
  null
  
)

export default component.exports